module.exports = __webpack_public_path__ + "img/Dai5-3p-re1.20dbeb72.png";